import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import moment from 'moment';

const selector = state => get(state, SCOPE);

export default selector;

export const selectedBarIntervalSelector = createSelector(
  selector,
  (store) => {
    const { selectedBar } = store;

    // if a bar is selected
    if (selectedBar) {
      const from = moment(selectedBar).format();
      const to = moment(selectedBar).add('hour', 1).format();
      return { from , to };
    }

    return null;
  },
);

export const selectedBarIndexSelector = createSelector(selector,
  (store) => {
    const { selectedIndex } = store;
    return selectedIndex;
  })
